import { connect } from 'react-redux';
import ProductSuppliersList from './index';

const mapStateToProps = ({ productSuppliers: { items } }) => ({
  suppliers: items,
});

export default connect(mapStateToProps)(ProductSuppliersList);
